<template>
  <div
    class="mx-auto flex justify-center bg-contain lg:bg-auto bg-footer bg-no-repeat pb-[100px] lg:pb-[325px]"
  >
    <img
      class="px-10 sm:px-0 w-[288px] h-[71px]"
      :src="DcukFooter"
      alt="DC-UK white logo"
    />
  </div>
</template>
<script>
import DcukFooter from "@/assets/DCUK-Logo-W-Leaf.svg";

export default {
  data() {
    return {
      DcukFooter,
    };
  },
};
</script>
